<template><div>123</div></template>
<script></script>
<style></style>
